import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import MDTypography from "components/MDTypography";
import { useTheme, alpha } from "@mui/material/styles";

export default function DemoProgressBar({ current, total }) {
  const theme = useTheme();
  const pct = total > 0 ? Math.min(100, Math.round((current / total) * 100)) : 0;
  const primary = theme.palette.primary.main;

  return (
    <Box sx={{ width: "100%", mb: 2 }}>
      <MDTypography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.75, fontWeight: 600 }}>
        Step {current} of {total}
      </MDTypography>
      <LinearProgress
        variant="determinate"
        value={pct}
        sx={{
          height: 6,
          borderRadius: 3,
          bgcolor: alpha(primary, 0.12),
          "& .MuiLinearProgress-bar": {
            borderRadius: 3,
            background: `linear-gradient(90deg, ${primary}, ${theme.palette.primary.dark || primary})`,
          },
        }}
      />
    </Box>
  );
}

DemoProgressBar.propTypes = {
  current: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};
